<template>
  <div v-if="isVisible" class="modal-overlay" @click.self="closeModal">
    <div class="modal-container">
      <header class="modal-header">
        <button class="modal-close" @click="closeModal">&times;</button>
        <slot />
      </header>
      <div class="modal-body">
        <slot name="title-video" />
        <div class="modal-line" />
      </div>
      <div class="modal-next-videos">
        <p class="text-white text-lg font-semibold">Próximos vídeos</p>
        <div>
          <slot name="next-videos" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Modal",
  props: {
    isVisible: {
      type: Boolean,
      required: true
    },
  },
  methods: {
    closeModal() {
      this.$emit("close");
    }
  }
};
</script>

<style scoped>
.modal-body {
  padding: 15px;
  margin-top: 5px;
}

.modal-next-videos {
  padding-inline: 15px;
}

.modal-line {
  width: 100%;
  height: 1px;
  background: #4F4F4F;
  margin-top: 30px;
  margin-bottom: 30px;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99999999999;
}
.modal-container {
  background: #27272A;
  width: 100%;
  height: 100%;
  overflow: auto;
  padding-bottom: 20px;
}
.modal-header {
  display: flex;
  justify-content: flex-end;
  position: relative;
  align-items: center;
}
.modal-close {
  background: none;
  border: none;
  font-size: 2.5em;
  cursor: pointer;
  position: absolute;
  width: 46px;
  height: 46px;
  background: #fff;
  border-radius: 50%;
  top: 10px;
  right: 10px;
  z-index: 99999999999;
}
</style>
